// extracted by mini-css-extract-plugin
module.exports = {"root":"DropDisabledInfo_root__3h6sd","text":"DropDisabledInfo_text__3KRt2","icon":"DropDisabledInfo_icon__UCAno"};